<template>
	<svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 10V5C4 3.89543 4.89543 3 6 3M4 21.5V24" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M18 5C18 3.89543 17.1046 3 16 3" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M11 1V5M9 3H13" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M1 24L27 24" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<g opacity="0.35">
		<path d="M9 24V20M9 20H12M9 20H8" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<circle cx="11" cy="14" r="1" :fill="color"/>
		<circle cx="8" cy="11" r="1" :fill="color"/>
		<circle cx="8" cy="8" r="1" :fill="color"/>
		<circle cx="11" cy="11" r="1" :fill="color"/>
		<circle cx="11" cy="8" r="1" :fill="color"/>
		<circle cx="14" cy="11" r="1" :fill="color"/>
		<circle cx="14" cy="8" r="1" :fill="color"/>
		</g>
		<path d="M18 14V11.4286M18 11.4286V8H23L21 9.71429L23 11.4286H18Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M25 24V16C25 14.8954 24.1046 14 23 14H15C13.8954 14 13 14.8954 13 16V24" :stroke="color" stroke-width="2" stroke-linecap="round"/>
		<g opacity="0.35">
		<circle cx="16" cy="17" r="1" :fill="color"/>
		<circle cx="19" cy="17" r="1" :fill="color"/>
		<circle cx="22" cy="17" r="1" :fill="color"/>
		<path d="M17 24V20M17 20H21M17 20H16M21 20V24M21 20H22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</g>
		<path d="M8 15C8 16.1046 7.10355 17 5.99773 17C5.44684 17 4.94791 16.7778 4.58589 16.4182M5.99773 13C4.8919 13 3.99545 13.8954 3.99545 15C3.99545 15.5543 4.22121 16.0559 4.58589 16.4182M4.58589 16.4182L1 20" :stroke="color" stroke-width="2" stroke-linecap="round"/>
	</svg>
</template>

<script>
  	export default {
    	name: 'moduleL',
    	props: ['color'],
    }
</script>